import { AppThunk, APPEND_CHATGROUPS_SUCCESS, FETCH_CHATGROUPS_SUCCESS, FETCH_TOTAL_AVAILABLE_QUERIES, SET_CHAT_GROUP_ID, SET_CHAT_GROUP_TITLE, SET_SELECTED_MODEL } from "../types";
import apis from "../../utils/apis";
import { showFeedbackModal } from "./UserFeedbackActions";
import { ChatHistoryResponse } from "../../components/Chat/types";
import { handleApiError } from "./utils/utils";
import { translate } from '../../i18n/translate';
import logger from '../../utils/logger';

export const FETCH_SERVICES_SUCCESS = 'FETCH_SERVICES_SUCCESS';

export const getUserID = () => {
  try {
    const stored = sessionStorage.getItem("userInfo");
    if (stored) {
      const parsed = JSON.parse(stored);
      return parsed.userId || parsed.UserID || parsed.user_id || null;
    }
  } catch (e) {
  }
  return null;
};

export const getUserType = () => {
  try {
    const stored = sessionStorage.getItem("userInfo");
    if (stored) {
      const parsed = JSON.parse(stored);
      return parsed.userType || parsed.UserType || parsed.user_type || null;
    }
  } catch (e) {
  }
  return null;
};

export const getKycStatus = () => {
  try {
    const stored = sessionStorage.getItem("userInfo");
    if (stored) {
      const parsed = JSON.parse(stored);
      return parsed.kycStatus || parsed.KycStatus || parsed.kyc_status || null;
    }
  } catch (e) {
  }
  return null;
};

export interface Citation {
  id: string;
  law: string;
  paragraph: string;
  section: string;
  snippet: string;
  title: string;
  favicon?: string;
  url: string;
  number?: number;
}

export interface SomeInputType {
  LCMID: string;
  UserID: string;
  Section: string;
  SectionData: string;
  UserType: string
}


export interface ApiResponse {
  ConfirmMessage: string;
  DataID: string;
  NextSection: string;
  Output: string;
  Section: string;
  SectionData: string;
  UserFullName: string;
  UserID: string;
  LCM?: any;
}

export interface AIModel {
  model_content: string;
  model_display_name: string;
  model_id: number;
  model_name: string;
  model_role: string;
  total_available_queries?: string | number;
  is_user_index?: boolean;
}


export interface ServiceAPIResponse {
  LawAgentResponse?: string;
  final_response?: string;
  LawCitations?: Citation[];
  progress?: any[];
  UnifiedResponse?: string;
  ContractAnalysisResponse?: string;
  ContractGeneratorResponse?: string;
  CaseAgentResponse?: string;
  TaxAgentResponse?: string;
  ChatResponse?: string;
  ChatGroupID?: string;
  ChatID?: string; 
  ChatTitle?: string;    
  ContractGenerationResponse?: string
  message?: string;
  Citations?: Citation[];
}

export interface ChatGroupData {
  AIType: string,
  ChatGroupID: string,
  ChatTitle: string,
  CreationDate: string,
  LastModified: string,
  UserID: string,
  id: string,
  status: string,
  // Research chat fields (from ResearchChatGroup)
  uuid?: string,
  title?: string,
  last_message_at?: string,
  updated_at?: string,
  created_at?: string,
  total_messages?: number,
  country?: string,
  /** Research: the caller owns this chat (created it). Gates destructive actions. */
  is_owner?: boolean,
  is_shared?: boolean,
  sources?: Array<{ source_type: string; source_identifier: string; source_name?: string }>,
}


export const setSelectedModel = (model: AIModel) => {
  localStorage.setItem('selectedModel', JSON.stringify(model));
  return {
    type: SET_SELECTED_MODEL,
    payload: model,
  };
};


export const setChatGroupIDStore = (chatGroupID: string) => {
  localStorage.setItem('chatGroupID', chatGroupID);
  return {
    type: SET_CHAT_GROUP_ID,
    payload: chatGroupID,
  };
};

export const addChatGroup = (chatGroup: ChatGroupData) => ({
  type: 'ADD_CHAT_GROUP',
  payload: chatGroup,
});

export const callLCMAPI = async (data: SomeInputType): Promise<ApiResponse> => {
  try {
    const response = await apis({
      method: "POST",
      url: "ponsai/lcm/generateLCM",
      data: data
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};


export const callServiceAPI = async (
  service: string,
  data: any,
  files: File[] = [],
  groupID: string = ''
): Promise<ServiceAPIResponse> => {
  let endpoint;
  let payload: FormData | Record<string, any>;
  let headers = {};

  const commonData = {
    ...data,
    GroupID: groupID,
  };

  switch (service) {
    case 'Orchestrator':
      endpoint = '/ai/router';
      payload = {
        ...commonData,
        service
      }
      break;
    case 'LawAgent':
      endpoint = 'ai/generate_law_research';
      payload = commonData;
      break;
    case 'TaxAgent':
      endpoint = 'ai/generate_tax_research';
      payload = commonData;
      break;
    case 'CaseAgent':
      endpoint = 'ai/generate_case_research';
      payload = commonData;
      break;
      case 'ContractAdvisor':
        endpoint = '/ai/generate_contract_analysis';
        const formData = new FormData();
        formData.append('GroupID', groupID);
        if (files.length > 0) {
          files.forEach((file) => {
            formData.append('Files', file);
          });
        } else {
          formData.append('Files', new Blob(), ''); 
        }
        Object.keys(data).forEach((key) => {
          formData.append(key, data[key]);
        });
        payload = formData;
        break;
    case 'ContractGenerator':
      endpoint = 'ponsai/contractGenerator';
      payload = commonData;
      break;
    case 'CompanyAgent':
      endpoint = 'ai/company_agent/chat';
      payload = {
        ...data,
      };
      break;
    case 'CustomAgent':
      endpoint = 'ai/custom_agent/chat';
      payload = {
        ...data,
      };
      break;
    default:
      throw new Error('Service not recognized');
  }

  try {
    const response = await apis({
      method: 'POST', 
      url: endpoint,
      data: payload,
      headers: headers,
    });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};


export interface ChatGroupData {
  AIType: string,
  ChatGroupID: string,
  ChatTitle: string,
  CreationDate: string,
  LastModified: string,
  UserID: string,
  id: string,
  status: string,
  // Research chat fields (from ResearchChatGroup)
  uuid?: string,
  title?: string,
  last_message_at?: string,
  updated_at?: string,
  created_at?: string,
  total_messages?: number,
  country?: string,
  /** Research: the caller owns this chat (created it). Gates destructive actions. */
  is_owner?: boolean,
  is_shared?: boolean,
  sources?: Array<{ source_type: string; source_identifier: string; source_name?: string }>,
}

export const chatGroupApi = (AIType: string): AppThunk => async (dispatch) => {
  try {
    let response = await apis({
      method: "POST",
      url: "ai/get_chat_groups",
      data: {
        AIType,
      }
    })

    if (response && response.status === 200) {
      dispatch({
        type: FETCH_CHATGROUPS_SUCCESS,
        payload: response.data.Chats
      });
      return response.data.Chats
    } else {
      handleApiError(response, dispatch)
    }

  } catch (err) {
    handleApiError(err, dispatch)
  }

}


export const createChatGroup = (): AppThunk<Promise<{ GroupID: string }>> => async (dispatch) => {
  try {
    const response = await apis({
      method: 'POST',
      url: 'ai/create_chat_group',
      data: { AIType: 'Orchestrator' },
    });
    if (response.status === 200) {
      return response.data; 
    } else {
      throw new Error('Failed to create chat group');
    }
  } catch (error) {
    throw error;
  }
};

export const uploadFiles = (files: File[], groupID: string): AppThunk<any> => async (dispatch: any) => {
  try {
    const formData = new FormData();
    files.forEach((file) => formData.append('files', file));
    formData.append('GroupID', groupID);
    const response = await apis({
      method: 'POST',
      url: 'ai/upload_contracts',
      data: formData,
    });
    if (response.status === 200) {
      return response.data; 
    } else {
      throw new Error('Failed to upload files');
    }
  } catch (error) {
    throw error; 
  }
};

export const stopOrchestratorStream = (data: { group_id: string }): AppThunk<Promise<void>> => async (dispatch) => {
  try {
    const response = await apis({
      method: 'POST',
      url: 'ai/orchestrator/stop',
      data,
    });
    if (response.status !== 200) {
      throw new Error('Failed to stop stream');
    }
  } catch (error) {
    throw error;
  }
};

export const chatHistoryApi = (
  AIType: string,
  GroupID: string,
  signal: AbortSignal
): AppThunk<Promise<ChatHistoryResponse>> => async (dispatch) => {
  try {
    let response = await apis({
      method: "POST",
      url: "ai/get_ai_chat_history",
      data: { AIType, GroupID },
      signal: signal, 
    });
    if (response && response.status === 200) {
      return response.data as ChatHistoryResponse;
    } else {
      handleApiError(response, dispatch)
      throw new Error('Unable to fetch chat history');

    }
  } catch (err: any) {
    if (err.name !== 'AbortError') {
      handleApiError(err, dispatch)
    }
    throw err;
  }
};

export const deleteChatGroup = (GroupID: string,): AppThunk => async (dispatch) => {
  try {
    let response = await apis({
      method: "POST",
      url: "ai/delete_chat_group",
      data: {
        GroupID,
      }
    })

    if (response && response.status === 200) {
      dispatch(showFeedbackModal({
        showModal: true,
        message: translate('Chat deleted'),
        modalType: 'success',
        duration: 3000
      }));
      return response.data
    } else {
      handleApiError(response, dispatch)
    }

  } catch (err) {
    handleApiError(err, dispatch)
  }
}


export const submitChatFeedback = (
  ChatID: string,
  GroupID: string,
  Like: string,
  Dislike: string,
  Comment: string
): AppThunk => async (dispatch) => {
  try {
    let response = await apis({
      method: "POST",
      url: "ai/chat_feedback",
      data: {
        UserID: getUserID(),
        UserType: getUserType(),
        ChatID,
        GroupID,
        Like,
        Dislike,
        Comment
      }
    });

    if (response && response.status === 200) {
      dispatch(showFeedbackModal({
        showModal: true,
        message: translate('Feedback submitted'),
        modalType: 'success',
        duration: 3000
      }));
      return response.data;
    } else {
      handleApiError(response, dispatch)
    }
  } catch (err) {
    handleApiError(err, dispatch)
  }
};


export const getAiModels = (project_id?: string) => {
  return async (dispatch: any) => {
    try {
      const response = await apis({
        method: "POST",
        url: "/ai/models",
        data:{
          project_id
        }
      })
      if (response && response.status === 200) {
        
        dispatch({ type: FETCH_SERVICES_SUCCESS, payload: response.data.services as AIModel[]});
        dispatch({ type: FETCH_TOTAL_AVAILABLE_QUERIES, payload: response.data.total_available_queries});
        return response.data.services
      } else {
        handleApiError(response, dispatch)
      }
    } catch (err) {
      handleApiError(err, dispatch)
    }

  }
}

export const deleteChatHistory = (GroupID: string, UserID: string, UserType: string) => {
  return async (dispatch: any) => {
    try {
      const response = await apis({
        method: "POST",
        url: "ponsai/deleteChatHistory",
        data: {
          GroupID,
          UserID,
          UserType
        }
      })
      if (response && response.status === 200) {
        return response.data
      } else {
        handleApiError(response, dispatch)
      }
    } catch (err) {
      handleApiError(err, dispatch)
    }

  }
}

export const updateChatTitle = (GroupID: string, newTitle: string) => {
  return async (dispatch: any) => {
    try {
      const response = await apis({
        method: "POST",
        url: "ai/update_chat_title",
        data: {
          GroupID: GroupID,
          NewTitle: newTitle
        }
      })
      if (response && response.status === 200) {
        return response.data
      } else {
        handleApiError(response, dispatch)
      }
    } catch (err) {
      handleApiError(err, dispatch)
    }
  }
}


// =============================================================================
// Research API Functions (new backend endpoints)
// =============================================================================

/**
 * One selectable research source.
 *
 * Mirrors what `ResearchService.get_available_sources` returns.
 *
 * A jurisdiction row is ONE LIVE INDEX, not a category: `source_identifier`
 * is the real index name (e.g. "bulgaria-case_law-vks") and is the exact
 * string retrieval targets, so selection stores it verbatim. The country lives
 * in `jurisdiction`, and `source_type` is `jurisdiction_<canonical>` — never
 * switch on an exhaustive list of law/case.
 */
export interface ResearchSource {
  source_type: string;       // 'jurisdiction_*' | 'user_datasource'
  source_identifier: string; // ISO country code, or datasource UUID
  source_name?: string;
  document_count?: number;
  description?: string;
  status?: string;           // 'ready' | 'processing' … (user datasources)

  /* ── jurisdiction rows only (additive, from discovery) ───────── */
  /** ISO country code, e.g. "BG". NOT the identifier — that is the index. */
  jurisdiction?: string;
  /** Friendly country label, e.g. "Bulgaria". */
  jurisdiction_name?: string;
  /** Raw category folder, e.g. `legislation` | `case_law` | `gazette`. */
  category?: string;
  /** Human label for the category, e.g. "Case Law". */
  category_label?: string;
  /** Canonical discovery type behind the wire `source_type`. */
  canonical_source_type?: string;
}

/** The `available-sources` response — note the key is `user_datasources`. */
export interface ResearchAvailableSources {
  jurisdiction_sources: ResearchSource[];
  user_datasources: ResearchSource[];
}

/* ------------------------------------------------------------------ */
/*  Per-session settings                                               */
/* ------------------------------------------------------------------ */

/** Which layer answered for a field. */
export type SettingsSource = 'session' | 'ai_settings' | 'default' | 'none';

/** The resolved values a query will actually run with. */
export interface ResearchEffectiveSettings {
  jurisdiction: string | null;
  jurisdiction_source: SettingsSource;
  output_language: string;
  output_language_source: SettingsSource;
  sources: ResearchSource[];
  sources_source: SettingsSource;
}

export interface ResearchSessionSettings {
  chat_uuid: string;
  effective: ResearchEffectiveSettings;
  /** Null means "inherited" — no override set on this chat. */
  overrides: {
    jurisdiction: string | null;
    output_language: string | null;
  };
}

/**
 * A settings patch. OMIT a key to leave it untouched; send `null` to CLEAR the
 * override back to the user's AI settings. `undefined` keys are dropped before
 * the request so the two cases stay distinguishable on the wire.
 */
export interface ResearchSettingsPatch {
  jurisdiction?: string | null;
  output_language?: string | null;
  sources?: Array<Pick<ResearchSource, 'source_type' | 'source_identifier' | 'source_name'>>;
}

export interface ResearchChatGroup {
  uuid: string;
  title: string;
  country: string | null;
  status: string;
  total_messages: number;
  total_tokens_used: number;
  last_message_at: string | null;
  matter_uuid: string | null;
  sources: ResearchSource[];
  created_at: string;
  updated_at: string;
}

export interface ResearchQueryResult {
  correlation_id: string;
  message_uuid: string;
  sequence_number: number;
  chat_uuid: string;
  status: string;
  /**
   * The chat's label as the server now holds it — the placeholder written for
   * a first query, or the settled title of an ongoing chat. Shown while the
   * answer is in flight so the header and the history row agree; the engine
   * replaces it with the generated title when the turn completes.
   */
  chat_title?: string;
  /**
   * CLARIFY GATE. Present when `status === 'awaiting_clarification'`, which
   * means the gate asked instead of running: NOTHING was enqueued and nothing
   * was metered. The questions are durable — closing the tab does not lose
   * them — and answering continues this same turn.
   */
  questions?: any[];
  plan?: any;
  trigger?: string;
  round?: number;
  max_rounds?: number;
}

export interface ResearchChatGroupPage {
  items: ResearchChatGroup[];
  total: number;
  has_more?: boolean;
  next_cursor?: string | null;
}

export const researchListChatGroups = (
  page: number = 1,
  pageSize: number = 20,
  status?: string,
  matterId?: number,
  /** Append to the loaded window instead of replacing it (infinite scroll). */
  append: boolean = false
): AppThunk<Promise<ResearchChatGroupPage>> => async (dispatch) => {
  try {
    const params = new URLSearchParams({ page: String(page), page_size: String(pageSize) });
    if (status) params.set('status', status);
    if (matterId) params.set('matter_id', String(matterId));

    const response = await apis({
      method: "GET",
      url: `research/chat-groups?${params.toString()}`,
    });

    if (response?.status === 200) {
      dispatch({
        type: append ? APPEND_CHATGROUPS_SUCCESS : FETCH_CHATGROUPS_SUCCESS,
        payload: response.data.items,
      });
      return response.data;
    } else {
      handleApiError(response, dispatch);
      throw new Error('Failed to list research chats');
    }
  } catch (err) {
    handleApiError(err, dispatch);
    throw err;
  }
};

export const researchCreateChatGroup = (data: {
  title?: string;
  country?: string;
  matter_id?: number;
  matter_uuid?: string;
  sources?: ResearchSource[];
}): AppThunk<Promise<ResearchChatGroup>> => async (dispatch) => {
  try {
    const response = await apis({
      method: "POST",
      url: "research/chat-groups",
      data,
    });

    if (response?.status === 201) {
      return response.data;
    } else {
      handleApiError(response, dispatch);
      throw new Error('Failed to create research chat');
    }
  } catch (err) {
    handleApiError(err, dispatch);
    throw err;
  }
};

export const researchGetChatGroup = (chatUuid: string): AppThunk<Promise<ResearchChatGroup>> => async (dispatch) => {
  try {
    const response = await apis({
      method: "GET",
      url: `research/chat-groups/${chatUuid}`,
    });

    if (response?.status === 200) {
      return response.data;
    } else {
      handleApiError(response, dispatch);
      throw new Error('Failed to get research chat');
    }
  } catch (err) {
    handleApiError(err, dispatch);
    throw err;
  }
};

/**
 * Rename one loaded chat row locally — no request, no refetch.
 *
 * The server already holds this name (it generated it, or the rename PATCH
 * just wrote it); this is only so the sidebar says it at the same instant
 * the breadcrumb does, instead of a list refetch later.
 */
export const setChatGroupTitleLocally = (uuid: string, title: string) => ({
  type: SET_CHAT_GROUP_TITLE,
  payload: { uuid, title },
});

export const researchUpdateChatGroup = (
  chatUuid: string,
  data: { title?: string; status?: string; country?: string; sources?: ResearchSource[] }
): AppThunk<Promise<void>> => async (dispatch) => {
  try {
    const response = await apis({
      method: "PUT",
      url: `research/chat-groups/${chatUuid}`,
      data,
    });

    if (response?.status !== 200) {
      handleApiError(response, dispatch);
    }
  } catch (err) {
    handleApiError(err, dispatch);
  }
};

export const researchDeleteChatGroup = (chatUuid: string): AppThunk => async (dispatch) => {
  try {
    const response = await apis({
      method: "DELETE",
      url: `research/chat-groups/${chatUuid}`,
    });

    if (response?.status === 200) {
      dispatch(showFeedbackModal({
        showModal: true,
        message: translate('Research chat deleted'),
        modalType: 'success',
        duration: 3000,
      }));
      return response.data;
    } else {
      handleApiError(response, dispatch);
    }
  } catch (err) {
    handleApiError(err, dispatch);
  }
};

export interface ResearchQueryOptions {
  /** Uploaded attachment UUIDs to scope the query to. */
  attachmentUuids?: string[];
  /** Pin the answer shape. Omit to let the engine classify. */
  intent?: string;
  /**
   * Link this chat to a matter as it starts.
   *
   * Only meaningful on the FIRST query of a chat that has no matter — later
   * turns inherit the link and must not re-send it (the backend ignores and
   * logs a mismatch; changing a link is `PUT /chat-groups/<uuid>/matter`).
   */
  matterUuid?: string;
}

export const researchSendQuery = (
  chatUuid: string,
  query: string,
  documentChunks?: string[],
  options?: ResearchQueryOptions
): AppThunk<Promise<ResearchQueryResult>> => async (dispatch) => {
  try {
    // `attachment_uuids` / `intent` are only sent when set — an empty or absent
    // value must not override the engine's own classification.
    const response = await apis({
      method: "POST",
      url: `research/chat-groups/${chatUuid}/query`,
      data: {
        query,
        document_chunks: documentChunks || [],
        ...(options?.attachmentUuids?.length
          ? { attachment_uuids: options.attachmentUuids }
          : {}),
        ...(options?.intent ? { intent: options.intent } : {}),
        ...(options?.matterUuid ? { matter_uuid: options.matterUuid } : {}),
      },
    });

    // 202 = accepted for processing. 200 = the CLARIFY GATE asked a question
    // instead: nothing was enqueued and nothing was metered, so the response
    // deliberately is not an acceptance. Both are successful sends and both
    // are returned; the caller branches on `status` in the body.
    if (response?.status === 202 || response?.status === 200) {
      return response.data;
    } else {
      handleApiError(response, dispatch);
      throw new Error('Failed to send research query');
    }
  } catch (err) {
    handleApiError(err, dispatch);
    throw err;
  }
};

export const researchStopProcessing = (chatUuid: string): AppThunk<Promise<void>> => async (dispatch) => {
  try {
    const response = await apis({
      method: "POST",
      url: `research/chat-groups/${chatUuid}/stop`,
    });

    if (response?.status !== 200) {
      handleApiError(response, dispatch);
    }
  } catch (err) {
    handleApiError(err, dispatch);
  }
};

/* ------------------------------------------------------------------ */
/*  Clarify gate — the pending question and its answer                 */
/* ------------------------------------------------------------------ */

/**
 * The chat's outstanding clarifying question, if it has one.
 *
 * Read on chat open, alongside the history page. A chat with nothing
 * outstanding answers `{pending: null}` — an empty result, never an error — so
 * this is safe to call on every open and its failure is never fatal: a
 * transcript that loads without its pending card is degraded; one that refuses
 * to load at all is broken.
 */
export const researchGetPendingPlan = (
  chatUuid: string
): AppThunk<Promise<any>> => async (dispatch) => {
  try {
    const response = await apis({
      method: "GET",
      url: `research/chat-groups/${chatUuid}/pending`,
    });
    return response?.status === 200 ? response.data : { pending: null };
  } catch (err) {
    // Deliberately quiet. See the docstring: this must not toast, and it must
    // not throw into the open() path.
    logger.debug('research: pending plan unavailable', { err });
    return { pending: null };
  }
};

/**
 * Answer an outstanding question and continue the SAME turn.
 *
 * `answers` is keyed by question id (or by slot; the backend accepts both).
 * Values follow the answer grammar in `clarify.ts`: an option id, a
 * `reframe:<slug>`, a locator (`upload:{uuid}#{chunk}`, `matter_doc:{name}`),
 * or free text.
 *
 * THE STATUS CODE IS THE CONTRACT, so it is returned alongside the body as
 * `http_status` and `classifyAnswerResult` reads it:
 *   * 202 — the turn is running. `{enqueued: true}` and `{already_running:
 *     true}` are both 202 and both mean "subscribe and watch"; the second is
 *     an attach to a run that beat this submit, NOT a refusal.
 *   * 200 `{status: 'awaiting_clarification', questions}` — round two. There
 *     is no round three.
 *   * 409 — and only 409 — is a turn that genuinely never started. It comes
 *     back rather than throwing, because it is an answer about the turn, not
 *     a transport failure, and the card has to keep the question answerable.
 */
export const researchAnswerClarification = (
  chatUuid: string,
  messageUuid: string,
  answers: Record<string, string>
): AppThunk<Promise<any>> => async (dispatch) => {
  try {
    const response = await apis({
      method: "POST",
      url: `research/chat-groups/${chatUuid}/messages/${messageUuid}/answers`,
      data: { answers },
    });
    if (response?.status === 202 || response?.status === 200) {
      return { ...(response.data || {}), http_status: response.status };
    }
    handleApiError(response, dispatch);
    throw new Error('Failed to submit the answer');
  } catch (err: any) {
    const status = err?.response?.status;
    if (status === 409) {
      // Not a transport failure and not a toast: the turn never started, the
      // question is still live, and the card says so where the user is
      // looking.
      return { ...(err?.response?.data || {}), http_status: 409 };
    }
    handleApiError(err, dispatch);
    throw err;
  }
};

/**
 * Edit the proposed plan, then run — the confirm tier's editable card.
 *
 * An edit IS an answer (changing the format answers the format slot), so this
 * returns exactly the two shapes `researchAnswerClarification` does.
 */
export const researchUpdatePendingPlan = (
  chatUuid: string,
  messageUuid: string,
  answers: Record<string, string>
): AppThunk<Promise<any>> => async (dispatch) => {
  try {
    const response = await apis({
      method: "PATCH",
      url: `research/chat-groups/${chatUuid}/messages/${messageUuid}/plan`,
      data: { answers },
    });
    if (response?.status === 202 || response?.status === 200) {
      return response.data;
    }
    handleApiError(response, dispatch);
    throw new Error('Failed to update the plan');
  } catch (err) {
    handleApiError(err, dispatch);
    throw err;
  }
};

/**
 * Give up on an unanswered question.
 *
 * NOT `researchStopProcessing`: there is nothing to stop, because nothing was
 * ever enqueued. Going through the stop path leaves the pending row behind and
 * the question reappears on the next open.
 */
export const researchAbandonPending = (
  chatUuid: string,
  messageUuid: string
): AppThunk<Promise<void>> => async (dispatch) => {
  try {
    const response = await apis({
      method: "DELETE",
      url: `research/chat-groups/${chatUuid}/messages/${messageUuid}/pending`,
    });
    if (response?.status !== 200) handleApiError(response, dispatch);
  } catch (err) {
    handleApiError(err, dispatch);
  }
};


/** One item in a message page — SQL metadata only, no blob content. */
export interface ResearchMessageItem {
  uuid: string;
  role: 'user' | 'assistant' | string;
  summary?: string;
  content?: string;
  status?: string;
  /** Answer shape, so the right skeleton renders before the blob loads. */
  intent?: string;
  /**
   * CLARIFY GATE: this turn is an unanswered question, not an answer.
   *
   * Known from the page read alone, so the transcript can place the question
   * without a second round trip per message. The question TEXT comes from
   * `GET /pending` — one call per chat, not one per turn.
   */
  pending?: boolean;
  sequence_number?: number;
  cursor?: string;
  citation_count?: number;
  created_at: string;
  /** THIS user's rating of the answer, if they have given one. */
  feedback?: 'up' | 'down' | null;
  /** Answer history — always at least one (synthetic) entry. */
  versions?: any[];
  current_version?: number;
  version_count?: number;
  /**
   * Files sent with a user message, when the backend echoes them.
   *
   * Uploads go to their own endpoint, so this may be absent; the shape is
   * read defensively in `attachmentsFromMessage`.
   */
  attachments?: any[];
}

export interface ResearchMessagePage {
  items: ResearchMessageItem[];
  total?: number;
  next_cursor?: string | null;
  prev_cursor?: string | null;
  has_more?: boolean;
}

export interface ResearchMessagesQuery {
  /** Keyset cursor — return the page immediately BEFORE this one. */
  before?: string | null;
  limit?: number;
}

/**
 * Fetch one keyset page of messages, newest-first window.
 *
 * Omit `before` for the most recent page; pass the previous response's
 * `next_cursor` to walk backwards through history.
 */
export const researchGetMessages = (
  chatUuid: string,
  query: ResearchMessagesQuery = {}
): AppThunk<Promise<ResearchMessagePage>> => async (dispatch) => {
  try {
    const params = new URLSearchParams({ limit: String(query.limit ?? 20) });
    if (query.before) params.set('before', query.before);

    const response = await apis({
      method: "GET",
      url: `research/chat-groups/${chatUuid}/messages?${params.toString()}`,
    });

    if (response?.status === 200) {
      return response.data;
    } else {
      handleApiError(response, dispatch);
      throw new Error('Failed to get messages');
    }
  } catch (err) {
    handleApiError(err, dispatch);
    throw err;
  }
};

/**
 * A stored answer.
 *
 * `version` selects one entry of the message's history — a number or a
 * version uuid. Omit it for whatever the backend considers current. An
 * unknown version is a 404 and MUST NOT quietly fall back to v1: showing v1
 * while the toggle says v3 is worse than showing an error.
 */
export const researchGetMessageContent = (
  chatUuid: string,
  messageUuid: string,
  version?: number | string | null
): AppThunk<Promise<any>> => async (dispatch) => {
  try {
    const query = version === undefined || version === null || version === ''
      ? ''
      : `?version=${encodeURIComponent(String(version))}`;
    const response = await apis({
      method: "GET",
      url: `research/chat-groups/${chatUuid}/messages/${messageUuid}/content${query}`,
    });

    if (response?.status === 200) {
      return response.data;
    } else {
      handleApiError(response, dispatch);
      throw new Error('Failed to get message content');
    }
  } catch (err) {
    handleApiError(err, dispatch);
    throw err;
  }
};

export type ResearchRating = 'up' | 'down' | null;

/**
 * Rate an answer.
 *
 * `null` clears the rating — clicking the active thumb toggles it off, so
 * there is no separate "unrate" call. The UI updates optimistically and
 * reverts on failure, so this deliberately does NOT raise a global toast:
 * the thumb springing back is the feedback.
 */
export const researchRateMessage = (
  chatUuid: string,
  messageUuid: string,
  rating: ResearchRating,
  /**
   * Which VERSION is being rated. Omitted → the current one, which is the
   * backend's default.
   *
   * NOTE: the field name mirrors `?version=` on the content endpoint. If the
   * backend settles on a different key, this is the only line to change.
   */
  version?: number | null
): AppThunk<Promise<boolean>> => async () => {
  const response = await apis({
    method: "POST",
    url: `research/chat-groups/${chatUuid}/messages/${messageUuid}/feedback`,
    data: {
      rating,
      ...(typeof version === 'number' ? { version } : {}),
    },
    validateStatus: () => true,
  });
  const ok = response?.status === 200 || response?.status === 201 || response?.status === 204;
  if (!ok) throw new Error('Failed to record feedback');
  return true;
};

/** What a 202 from the rerun endpoint carries. */
export interface ResearchRerunAccepted {
  /**
   * The NEW run's correlation id.
   *
   * A rerun/edit/refine is queued under a fresh correlation id — the backend
   * mints one per version and stamps it on both the version row and the
   * message row. It is the only handle on the live stream: without
   * subscribing to it the client sees nothing until the answer is fetched
   * back out of storage. Load-bearing, not informational.
   */
  correlation_id: string;
  /** The assistant message the version belongs to — unchanged by a rerun. */
  message_uuid?: string;
  chat_uuid?: string;
  version_uuid: string;
  version_number: number;
  origin: string;
  status: string;
  /** Refine only: the instruction the user gave, and what it worked from. */
  instruction?: string | null;
  refine_from_version?: number | null;
}

/**
 * Re-run an ANSWER, optionally with an edited question.
 *
 * `messageUuid` is the ASSISTANT message — the backend 400s on a user one.
 * Omitting `query` re-runs the original question as-is; sending one is
 * edit-and-run, and is also the only way through when the original cannot be
 * recovered (422).
 *
 * Rejections are meaningful and distinct — 409 still answering, 429 version
 * limit, 503 queue down — so the status is attached to the thrown error
 * rather than collapsed, and `handleApiError` is deliberately NOT called: the
 * turn shows the reason itself, and a global error toast on top of it would
 * be the same message twice.
 */
export const researchRerunMessage = (
  chatUuid: string,
  messageUuid: string,
  query?: string
): AppThunk<Promise<ResearchRerunAccepted>> => async () => {
  const clean = (query || '').trim();
  const response = await apis({
    method: "POST",
    url: `research/chat-groups/${chatUuid}/messages/${messageUuid}/rerun`,
    // Absent means "as-is". An empty string would read as an empty question.
    data: clean ? { query: clean } : {},
    // Every status is handled by the caller, including the rejections.
    validateStatus: () => true,
  });

  if (response?.status === 202) return response.data as ResearchRerunAccepted;

  const error: any = new Error('Failed to re-run this answer');
  error.status = response?.status;
  throw error;
};

/**
 * Refine an answer — improve THIS one, rather than start over.
 *
 * The third of three distinct actions on a turn: re-run is a fresh attempt at
 * the same question, edit is a different question, refine works from an
 * existing answer. `instruction` is optional — null means "just improve it" —
 * and `from_version` is omitted to refine whatever is current.
 *
 * Shares the rerun contract otherwise: 202 with the new version, and the same
 * meaningful rejections, so `rerunFailureFor` reads both. A 404 here is the
 * `from_version`, which is why it has its own reason.
 */
export const researchRefineMessage = (
  chatUuid: string,
  messageUuid: string,
  instruction?: string | null,
  fromVersion?: number | string | null
): AppThunk<Promise<ResearchRerunAccepted>> => async () => {
  const clean = (instruction || '').trim();
  const response = await apis({
    method: "POST",
    url: `research/chat-groups/${chatUuid}/messages/${messageUuid}/refine`,
    data: {
      // Blank means "just improve it" — an empty string would read as an
      // instruction that said nothing.
      instruction: clean || null,
      ...(fromVersion === undefined || fromVersion === null
        ? {}
        : { from_version: fromVersion }),
    },
    validateStatus: () => true,
  });

  if (response?.status === 202) return response.data as ResearchRerunAccepted;

  const error: any = new Error('Failed to refine this answer');
  error.status = response?.status;
  throw error;
};

export const researchConfirmCompletion = (
  chatUuid: string,
  messageUuid: string,
  completionData: {
    chat_name?: string;
    /**
     * True when `chat_name` is the engine's GENERATED title (from the
     * `research.completed` event). The backend uses it to replace a
     * placeholder title unconditionally — without it, a chat whose title is
     * still the raw first query keeps that query as its name forever.
     */
    chat_name_generated?: boolean;
    citation_count?: number;
    processing_time_ms?: number;
    summary?: string;
    blob_path?: string;
    prompt_tokens?: number;
    completion_tokens?: number;
    total_tokens?: number;
    model_used?: string;
    /**
     * WHICH ANSWER THIS SETTLES.
     *
     * A turn that has been re-run has several versions, and the reconcile
     * accumulates tokens per version. Omitting this makes the backend settle
     * whichever version is current AT THAT MOMENT — so a completion landing
     * after the user re-ran again would be written onto the newer version.
     * Naming the version removes the race.
     */
    version_uuid?: string;
    version_number?: number;
  }
): AppThunk<Promise<any>> => async (dispatch) => {
  try {
    const response = await apis({
      method: "POST",
      url: `research/chat-groups/${chatUuid}/messages/${messageUuid}/confirm-completion`,
      data: completionData,
    });

    if (response?.status === 200) {
      return response.data;
    }
    // Silently ignore errors — this is a best-effort reconciliation
  } catch {
    // Non-critical: the AI engine's internal notification may have succeeded
  }
};

/**
 * Upload attachments to a research chat group.
 *
 * The endpoint reads `request.files['file']` — a SINGLE file per request.
 * Callers must therefore pass one file at a time and collect each returned
 * uuid; passing several here would silently upload only one of them.
 */
export const researchUploadAttachment = (
  chatUuid: string,
  files: File[]
): AppThunk<Promise<any>> => async (dispatch) => {
  try {
    const formData = new FormData();
    files.slice(0, 1).forEach((file) => formData.append('file', file));

    const response = await apis({
      method: "POST",
      url: `research/chat-groups/${chatUuid}/attachments`,
      data: formData,
    });

    if (response?.status === 201) {
      return response.data;
    } else {
      handleApiError(response, dispatch);
      throw new Error('Failed to upload attachment');
    }
  } catch (err) {
    handleApiError(err, dispatch);
    throw err;
  }
};

export const researchGetAvailableSources =
  (): AppThunk<Promise<ResearchAvailableSources>> => async (dispatch) => {
  try {
    const response = await apis({
      method: "GET",
      url: "research/available-sources",
    });

    if (response?.status === 200) {
      return response.data;
    } else {
      handleApiError(response, dispatch);
      throw new Error('Failed to get available sources');
    }
  } catch (err) {
    handleApiError(err, dispatch);
    throw err;
  }
};

/** Read this session's effective settings, with provenance. */
export const researchGetSessionSettings = (
  chatUuid: string
): AppThunk<Promise<ResearchSessionSettings>> => async (dispatch) => {
  try {
    const response = await apis({
      method: "GET",
      url: `research/chat-groups/${chatUuid}/settings`,
    });

    if (response?.status === 200) {
      return response.data;
    } else {
      handleApiError(response, dispatch);
      throw new Error('Failed to read session settings');
    }
  } catch (err) {
    handleApiError(err, dispatch);
    throw err;
  }
};

/**
 * Set per-session overrides and get the recomputed effective settings back.
 *
 * Only keys present on `patch` are sent: an omitted key leaves that setting
 * untouched, while an explicit `null` clears the override back to the user's
 * AI settings. Passing `undefined` therefore must NOT reach the wire.
 */
export const researchSetSessionSettings = (
  chatUuid: string,
  patch: ResearchSettingsPatch
): AppThunk<Promise<ResearchSessionSettings>> => async (dispatch) => {
  try {
    const body: Record<string, any> = {};
    if ('jurisdiction' in patch) body.jurisdiction = patch.jurisdiction ?? null;
    if ('output_language' in patch) body.output_language = patch.output_language ?? null;
    if (Array.isArray(patch.sources)) {
      body.sources = patch.sources.map((s) => ({
        source_type: s.source_type,
        source_identifier: s.source_identifier,
        source_name: s.source_name || '',
      }));
    }

    const response = await apis({
      method: "PUT",
      url: `research/chat-groups/${chatUuid}/settings`,
      data: body,
    });

    if (response?.status === 200) {
      return response.data;
    } else {
      handleApiError(response, dispatch);
      throw new Error('Failed to update session settings');
    }
  } catch (err) {
    handleApiError(err, dispatch);
    throw err;
  }
};

/** What `researchStreamSource` gives a viewer. */
export interface ResearchSourceStream {
  blob: Blob;
  contentType: string;
  fileName: string;
}

/**
 * Stream a cited source document for inline display.
 *
 * `blob_path` off the citation is the ONLY identifier — not index_name, not
 * document_uuid — and it is passed through exactly as the engine emitted it.
 * A citation with an empty `blob_path` has no source to open; callers must not
 * offer the action rather than calling this and failing.
 *
 * A 200 is RAW BYTES, so this reads a blob and never parses JSON. Errors are
 * JSON with 401 / 403 / 400 — and **blob-not-found is 400, not 404**, so there
 * is deliberately no 404 branch here: anything non-200 is "couldn't load it".
 *
 * The route is chat-scoped and gated on research licence + view access to the
 * chat, so a research-only user (no matters permission) can open sources.
 */
export const researchStreamSource = (
  chatUuid: string,
  blobPath: string,
  contentType: string = 'text/html',
  container: string = ''
): AppThunk<Promise<ResearchSourceStream | null>> => async () => {
  if (!chatUuid || !blobPath) return null;
  try {
    const response = await apis({
      method: 'POST',
      url: `research/chat-groups/${chatUuid}/stream-source`,
      data: {
        blob_path: blobPath,
        // Only sent when the citation names one; an empty container means
        // the default, and the endpoint should not receive a blank field.
        ...(container ? { container } : {}),
        ContentType: contentType,
        Disposition: 'inline',
      },
      responseType: 'blob',
    });

    if (response?.status !== 200 || !response.data) return null;

    // Trust the response's own headers over the type we asked for.
    const headerType = String(response.headers?.['content-type'] || '').split(';')[0].trim();
    const disposition = String(response.headers?.['content-disposition'] || '');
    const named = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(disposition);

    return {
      blob: response.data as Blob,
      contentType: headerType || contentType,
      fileName: named ? decodeURIComponent(named[1]) : blobPath.split('/').pop() || 'source',
    };
  } catch {
    // An unopenable source must not break the answer around it; the caller
    // shows an inline "couldn't load" state.
    return null;
  }
};

/* ------------------------------------------------------------------ */
/*  Jurisdiction order                                                 */
/* ------------------------------------------------------------------ */

export interface JurisdictionOrderResult {
  order: string[];
  /** Keys the server did not recognise. Echoed, not an error. */
  ignored: string[];
}

/**
 * The user's preferred jurisdiction order.
 *
 * `[]` means never reordered — the picker then shows the platform default.
 * `available-sources` already returns rows in this order, so the picker does
 * not need this to RENDER; it needs it to drive the reorder UI's own state.
 */
export const researchGetJurisdictionOrder =
  (): AppThunk<Promise<string[]>> => async (dispatch) => {
    try {
      const response = await apis({ method: 'GET', url: 'research/jurisdiction-order' });
      if (response?.status === 200) {
        const order = response.data?.order;
        return Array.isArray(order) ? order.map(String) : [];
      }
      handleApiError(response, dispatch);
      return [];
    } catch (err) {
      // A picker that cannot read the preference still works, in default
      // order — this is never worth blocking on.
      return [];
    }
  };

/**
 * Store the whole top-to-bottom sequence.
 *
 * Always the FULL sequence, never a delta: the server stores what it is sent,
 * so a partial list would silently drop the jurisdictions left out of it.
 */
export const researchSetJurisdictionOrder = (
  order: string[]
): AppThunk<Promise<JurisdictionOrderResult | null>> => async (dispatch) => {
  try {
    const response = await apis({
      method: 'PUT',
      url: 'research/jurisdiction-order',
      data: { order },
    });
    if (response?.status === 200) {
      return {
        order: Array.isArray(response.data?.order) ? response.data.order.map(String) : [],
        ignored: Array.isArray(response.data?.ignored) ? response.data.ignored.map(String) : [],
      };
    }
    handleApiError(response, dispatch);
    return null;
  } catch (err) {
    handleApiError(err, dispatch);
    return null;
  }
};

/* ------------------------------------------------------------------ */
/*  Matter link                                                        */
/* ------------------------------------------------------------------ */

/** The linked matter as the matter-link endpoints return it. */
export interface ResearchLinkedMatter {
  uuid: string;
  id?: number;
  title?: string;
  matter_number?: string;
  jurisdiction?: string;
  status?: string;
}

/**
 * Read the matter this chat is linked to (`matter: null` when unlinked).
 *
 * The relation is `research_chat_groups.matter_id`/`.matter_uuid`; linking is
 * what puts the matter's documents and extracted context into the grounding
 * set for EVERY subsequent query in the session.
 */
export const researchGetMatterLink = (
  chatUuid: string
): AppThunk<Promise<ResearchLinkedMatter | null>> => async (dispatch) => {
  try {
    const response = await apis({
      method: "GET",
      url: `research/chat-groups/${chatUuid}/matter`,
    });

    if (response?.status === 200) {
      return response.data?.matter ?? null;
    } else {
      handleApiError(response, dispatch);
      throw new Error('Failed to read matter link');
    }
  } catch (err) {
    handleApiError(err, dispatch);
    throw err;
  }
};

/**
 * Link this chat to a matter, or clear the link when `matterUuid` is null.
 *
 * Clearing is a DELETE rather than a PUT with an empty body: the endpoint
 * requires `matter_uuid` on PUT and 400s without it.
 */
export const researchSetMatterLink = (
  chatUuid: string,
  matterUuid: string | null
): AppThunk<Promise<ResearchLinkedMatter | null>> => async (dispatch) => {
  try {
    const response = matterUuid
      ? await apis({
          method: "PUT",
          url: `research/chat-groups/${chatUuid}/matter`,
          data: { matter_uuid: matterUuid },
        })
      : await apis({
          method: "DELETE",
          url: `research/chat-groups/${chatUuid}/matter`,
        });

    if (response?.status === 200) {
      return response.data?.matter ?? null;
    } else {
      handleApiError(response, dispatch);
      throw new Error('Failed to update matter link');
    }
  } catch (err) {
    handleApiError(err, dispatch);
    throw err;
  }
};

export const researchGetContextInfo = (chatUuid: string): AppThunk<Promise<any>> => async (dispatch) => {
  try {
    const response = await apis({
      method: "GET",
      url: `research/chat-groups/${chatUuid}/context`,
    });

    if (response?.status === 200) {
      return response.data;
    } else {
      handleApiError(response, dispatch);
      throw new Error('Failed to get context info');
    }
  } catch (err) {
    handleApiError(err, dispatch);
    throw err;
  }
};


// =============================================================================
// Research Collaborator Actions
// =============================================================================

export const researchListCollaborators = (
  chatUuid: string
): AppThunk<Promise<any[]>> => async (dispatch) => {
  try {
    const response = await apis({
      method: "GET",
      url: `research/chat-groups/${chatUuid}/collaborators`,
    });

    if (response?.status === 200) {
      return response.data?.collaborators || response.data || [];
    } else {
      handleApiError(response, dispatch);
      return [];
    }
  } catch (err) {
    handleApiError(err, dispatch);
    return [];
  }
};

export const researchAddCollaborator = (
  chatUuid: string,
  collaboratorUserId: number | string,
  access: 'view' | 'edit' | 'admin' = 'view'
): AppThunk<Promise<any>> => async (dispatch) => {
  try {
    // Detect whether the value is a numeric ID or a UUID string
    const isNumeric = typeof collaboratorUserId === 'number' || /^\d+$/.test(String(collaboratorUserId));
    const data = isNumeric
      ? { collaborator_user_id: Number(collaboratorUserId), access }
      : { collaborator_uuid: String(collaboratorUserId), access };

    const response = await apis({
      method: "POST",
      url: `research/chat-groups/${chatUuid}/collaborators`,
      data,
    });

    if (response?.status === 200 || response?.status === 201) {
      return response.data;
    } else {
      handleApiError(response, dispatch);
      throw new Error('Failed to add collaborator');
    }
  } catch (err) {
    handleApiError(err, dispatch);
    throw err;
  }
};

export const researchUpdateCollaboratorAccess = (
  chatUuid: string,
  collaboratorUuid: string,
  access: 'view' | 'edit' | 'admin'
): AppThunk<Promise<any>> => async (dispatch) => {
  try {
    const response = await apis({
      method: "PATCH",
      url: `research/chat-groups/${chatUuid}/collaborators/${collaboratorUuid}`,
      data: { access },
    });

    if (response?.status === 200) {
      return response.data;
    } else {
      handleApiError(response, dispatch);
      throw new Error('Failed to update collaborator access');
    }
  } catch (err) {
    handleApiError(err, dispatch);
    throw err;
  }
};

export const researchRemoveCollaborator = (
  chatUuid: string,
  collaboratorUuid: string
): AppThunk<Promise<any>> => async (dispatch) => {
  try {
    const response = await apis({
      method: "DELETE",
      url: `research/chat-groups/${chatUuid}/collaborators/${collaboratorUuid}`,
    });

    if (response?.status === 200) {
      return response.data;
    } else {
      handleApiError(response, dispatch);
      throw new Error('Failed to remove collaborator');
    }
  } catch (err) {
    handleApiError(err, dispatch);
    throw err;
  }
};

export const researchUpdateSharing = (
  chatUuid: string,
  isShared: boolean
): AppThunk<Promise<any>> => async (dispatch) => {
  try {
    const response = await apis({
      method: "PUT",
      url: `research/chat-groups/${chatUuid}/sharing`,
      data: { is_shared: isShared },
    });

    if (response?.status === 200) {
      return response.data;
    } else {
      handleApiError(response, dispatch);
      throw new Error('Failed to update sharing');
    }
  } catch (err) {
    handleApiError(err, dispatch);
    throw err;
  }
};
